<template>
  <div>
    <filter-toolbar
      :hasChanges="hasChanges"
      :appliedFilters="appliedFilters"
      @search="search"
      @update="update"
      @clear="clear">
      <remote-facet-filter
        class="border-b"
        v-model="connectionFacetValue"
        response-type="object"
        :resourceLabel="(context.isSupplier()) ? 'retailer.name' : 'brand.name'"
        :resourceValue="(context.isSupplier()) ? 'retailer.id' : 'brand.id'"
        :filter="filterOptions.connection"
        :endpoint="context.route + '/connections/?short=1'"
        @input="change"
      />
      <boolean-filter
        class="border-b"
        v-model="filters.facets.is_acknowledged"
        :filter="filterOptions.acknowledged"
        @input="change"
      />
      <boolean-filter
        class="border-b"
        v-model="filters.facets.is_paid"
        :filter="filterOptions.isPaid"
        @input="change"
      />
      <boolean-filter
        class="border-b"
        v-model="filters.facets.has_credits"
        :filter="filterOptions.hasCredits"
        @input="change"
      />
      <boolean-filter
        class="border-b"
        v-model="filters.facets.has_rmas"
        :filter="filterOptions.hasRmas"
        @input="change"
      />
      <date-filter
        class="border-b"
        v-model="filters.timestamps.created_at"
        :filter="filterOptions.invoicedAt"
        @input="change"
      />
      <date-filter
        class="border-b"
        v-model="filters.timestamps.terms_date_due"
        :filter="filterOptions.dueAt"
        @input="change"
      />
      <date-filter
        class="border-b"
        v-model="filters.timestamps.acknowledged_at"
        :filter="filterOptions.acknowledgedAt"
        @input="change"
      />
      <date-filter
        v-model="filters.timestamps.paid_at"
        :filter="filterOptions.paidAt"
        @input="change"
      />
    </filter-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as filterOptions from '../../filters/invoices.js'
import FilterToolbar from '@/components/Filters/FilterToolbar'
import BooleanFilter from '@/components/Filters/BooleanFilter'
import DateFilter from '@/components/Filters/DateFilter'
import RemoteFacetFilter from '@/components/Filters/RemoteFacetFilter'

export default {
  components: {
    BooleanFilter,
    DateFilter,
    FilterToolbar,
    RemoteFacetFilter
  },
  data () {
    return {
      hasChanges: false,
      filters: null,
      // filters
      filterOptions: filterOptions
    }
  },
  computed: {
    ...mapGetters(['context']),
    connectionFacetKey () {
      return this.context.isSupplier() ? 'retailer_id' : 'brand_id'
    },
    connectionFacetValue: {
      get () {
        return (this.filters && this.filters.facets) ? this.filters.facets[this.connectionFacetKey] : undefined
      },
      set (value) {
        this.$set(this.filters.facets, this.connectionFacetKey, value)
      }
    }
  },
  methods: {
    change () {
      this.hasChanges = true
    },
    search (searchQuery) {
      this.filters.search = {
        parameter: 'search',
        query: searchQuery
      }
      this.$emit('filter', this.filters)
    },
    update () {
      this.hasChanges = false
      this.filters.preset = 'custom'
      this.$emit('filter', this.filters)
    },
    clear () {
      this.filters = {
        preset: 'all',
        facets: {},
        search: {},
        timestamps: {}
      }
      this.$emit('filter', this.filters)
    }
  },
  mounted () {

  },
  props: {
    appliedFilters: {
      type: Object,
      required: true
    }
  },
  watch: {
    appliedFilters: {
      deep: true,
      immediate: true,
      handler (filters) {
        this.filters = filters
      }
    }
  }
}
</script>
